var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.30709 6.25891C2.05028 7.8941 1.10259 9.77879 0.550781 11.8262H8.87441L3.30709 6.25891Z",
    fill: "#0052B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4485 11.8262C30.8967 9.77885 29.9489 7.89416 28.6922 6.25897L23.125 11.8262H31.4485Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.550781 20.174C1.10266 22.2214 2.05034 24.1061 3.30709 25.7412L8.87422 20.174H0.550781Z",
    fill: "#0052B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7411 3.30758C24.1059 2.05077 22.2213 1.10308 20.1738 0.551208V8.87477L25.7411 3.30758Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25781 28.6924C7.893 29.9492 9.77769 30.8969 11.8251 31.4488V23.1253L6.25781 28.6924Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 0.551208C9.77762 1.10308 7.89294 2.05077 6.25781 3.30752L11.825 8.87471V0.551208Z",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 31.4488C22.2212 30.8969 24.1059 29.9492 25.741 28.6925L20.1738 23.1253V31.4488Z",
    fill: "#0052B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 20.174L28.6922 25.7413C29.9489 24.1061 30.8967 22.2214 31.4485 20.174H23.125Z",
    fill: "#0052B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8646 13.9131H18.0871H18.087V0.135438C17.4038 0.0465 16.7073 0 16 0C15.2926 0 14.5962 0.0465 13.9131 0.135438V13.9129V13.913H0.135438C0.0465 14.5962 0 15.2927 0 16C0 16.7074 0.0465 17.4038 0.135438 18.0869H13.9129H13.913V31.8646C14.5962 31.9535 15.2926 32 16 32C16.7073 32 17.4038 31.9536 18.0869 31.8646V18.0871V18.087H31.8646C31.9535 17.4038 32 16.7074 32 16C32 15.2927 31.9535 14.5962 31.8646 13.9131Z",
    fill: "#D80027"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 20.174L27.3136 27.3138C27.642 26.9855 27.9552 26.6423 28.2541 26.2866L22.1415 20.174H20.1738V20.174Z",
    fill: "#D80027"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8254 20.174H11.8252L4.68555 27.3137C5.0138 27.6421 5.35698 27.9553 5.71273 28.2542L11.8254 22.1414V20.174Z",
    fill: "#D80027"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 11.8262V11.8261L4.68659 4.68628C4.35822 5.01453 4.04497 5.35772 3.74609 5.71347L9.85878 11.8262H11.8263V11.8262Z",
    fill: "#D80027"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1738 11.8262L27.3136 4.68629C26.9854 4.35791 26.6422 4.04466 26.2865 3.74585L20.1738 9.85854V11.8262Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUnitedKingdom);
export default __webpack_public_path__ + "static/media/flagUnitedKingdom.10af70d40b0cab529015ff9fe8f913f3.svg";
export { ForwardRef as ReactComponent };